export const platform_events = {
  partner_user_invite: {
    category: 'Partner users',
    action: 'Operator invites a user',
    label: 'partner_user_invite',
  },
  partner_user_update: {
    category: 'Partner users',
    action: 'Operator updates a user',
    label: 'partner_user_update',
  },
  partner_user_status_change: {
    category: 'Partner users',
    action: 'Operator deactivates or reactivates a user',
    label: 'partner_user_status_change',
  },
  partner_user_remove: {
    category: 'Partner users',
    action: 'Operator removes a user',
    label: 'partner_user_remove',
  },
  partner_user_invite_resend: {
    category: 'Partner users',
    action: 'Operator resends an invitation',
    label: 'partner_user_invite_resend',
  },
  partner_wallet_topup_start: {
    category: 'Partner wallet',
    action: 'Operator starts a wallet top-up',
    label: 'partner_wallet_topup_start',
  },
  partner_wallet_topup_success: {
    category: 'Partner wallet',
    action: 'Wallet top-up is credited',
    label: 'partner_wallet_topup_success',
  },
  partner_wallet_topup_failure: {
    category: 'Partner wallet',
    action: 'Wallet top-up fails',
    label: 'partner_wallet_topup_failure',
  },
  partner_communication_resend: {
    category: 'Partner communications',
    action: 'Operator resends a customer message',
    label: 'partner_communication_resend',
  },
};
